import { NavLink } from "react-router-dom";
import { LayoutDashboard, FileText, MapPin, Map as MapIcon, Bell } from "lucide-react";
import { cn } from "@/lib/utils";

const items = [
  { to: "/dashboard", label: "Home", icon: LayoutDashboard },
  { to: "/reports", label: "Reports", icon: FileText },
  { to: "/sites", label: "Sites", icon: MapPin },
  { to: "/gis", label: "GIS", icon: MapIcon },
  { to: "/notifications", label: "Alerts", icon: Bell },
];

export default function BottomNav() {
  return (
    <nav
      aria-label="Primary"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-border/60 bg-card/90 backdrop-blur-xl pb-[env(safe-area-inset-bottom)]"
    >
      <ul className="grid grid-cols-5">
        {items.map((it) => (
          <li key={it.to}>
            <NavLink
              to={it.to}
              className={({ isActive }) =>
                cn(
                  "flex flex-col items-center justify-center gap-1 py-2 text-[10px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset",
                  isActive
                    ? "text-primary"
                    : "text-muted-foreground hover:text-foreground",
                )
              }
            >
              {({ isActive }) => (
                <>
                  <span className="relative flex flex-col items-center">
                    <it.icon
                      className={cn(
                        "h-5 w-5 transition-transform",
                        isActive && "scale-110 text-foreground",
                      )}
                    />
                    {isActive && (
                      <span
                        aria-hidden="true"
                        className="absolute -bottom-1 h-1 w-1 rounded-full bg-[hsl(var(--brand-gold))] shadow-[0_0_6px_hsl(var(--brand-gold)/0.9)]"
                      />
                    )}
                  </span>
                  <span>{it.label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
